import { Path } from '@/main/router/routerPath';

import { CompletedRequest } from './CompletedRequest';
import { PendingRequest } from './PendingRequest';

export const router = new Path('ApprovalWorkflow').addChildren([
	PendingRequest.router,
	CompletedRequest.router,
]);
